import { createSlice, PayloadAction } from "@reduxjs/toolkit"
// import UAParser from "ua-parser-js"
import { Lang } from "@/autoImport/i18n"
import { earnPointResponse, txnGA, txnResponse } from "./api"

export interface AppState {
  loading: boolean
  lang: Lang
  errMsg: string
  // clientType: number
  invoiceQRCode: string
  pos: string
  token: string
  phone: string
  
  txn: null | txnResponse
  txnGA: null | txnGA
  earnPointResponse: null | earnPointResponse
  subscribed: boolean
}

// let parser = new UAParser("user-agent")
// let parserResults = parser.getResult()

const initialState: AppState = {
  loading: true,
  lang: "zh",
  errMsg: "",
  // clientType: parserResults.os.name === "iOS" ? 0 : 1,
  invoiceQRCode: "",
  pos: "storellet",
  token: "",
  phone: "",
  txn: null,
  txnGA: null,
  earnPointResponse: null,
  subscribed: false,
}

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
// export const incrementAsync = createAsyncThunk(
//   "counter/fetchCount",
//   async (amount: number) => {
//     const response = await fetchCount(amount)
//     // The value we return becomes the `fulfilled` action payload
//     return response.data
//   },
// )

export const appSlice = createSlice({
  name: "app",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    changeLang: (state, action: PayloadAction<Lang>) => {
      state.lang = action.payload
    },
    changeLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    changeErrMsg: (state, action: PayloadAction<string>) => {
      state.errMsg = action.payload
    },
    changeInvoiceQRCode: (state, action: PayloadAction<string>) => {
      state.invoiceQRCode = action.payload
    },
    changeToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    },
    changePhone: (state, action: PayloadAction<string>) => {
      state.phone = action.payload
    },
    changeTxn: (state, action: PayloadAction<null | txnResponse>) => {
      state.txn = action.payload
    },
    changeTxnGA: (state, action: PayloadAction<null | txnGA>) => {
      state.txnGA = action.payload
    },
    changePos: (state, action: PayloadAction<string>) => {
      state.pos = action.payload
    },
    changeEarnPointResponse: (
      state,
      action: PayloadAction<null | earnPointResponse>,
    ) => {
      state.earnPointResponse = action.payload
    },
    changeSubscribed: (state, action: PayloadAction<boolean>) => {
      state.subscribed = action.payload
    }
    // increment: (state) => {
    // Redux Toolkit allows us to write "mutating" logic in reducers. It
    // doesn't actually mutate the state because it uses the Immer library,
    // which detects changes to a "draft state" and produces a brand new
    // immutable state based off those changes
    //   state.value += 1
    // },
    // decrement: (state) => {
    //   state.value -= 1
    // },
    // Use the PayloadAction type to declare the contents of `action.payload`
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload
    // },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(incrementAsync.pending, (state) => {
  //       state.status = "loading"
  //     })
  //     .addCase(incrementAsync.fulfilled, (state, action) => {
  //       state.status = "idle"
  //       state.value += action.payload
  //     })
  //     .addCase(incrementAsync.rejected, (state) => {
  //       state.status = "failed"
  //     })
  // },
})

export const {
  changeLang,
  changeLoading,
  changeErrMsg,
  changeInvoiceQRCode,
  changeToken,
  changePhone,
  changeTxn,
  changeTxnGA,
  changePos,
  changeEarnPointResponse,
  changeSubscribed,
} = appSlice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
// export const selectCount = (state: RootState) => state.counter.value

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd =
//   (amount: number): AppThunk =>
//   (dispatch, getState) => {
//     const currentValue = selectCount(getState())
//     if (currentValue % 2 === 1) {
//       dispatch(incrementByAmount(amount))
//     }
//   }

export default appSlice.reducer
